import { Outlet } from 'react-router-dom';

import RootLayout from '@/layouts/RootLayout';

/**
 * Root layout component that wraps all routes with the root layout
 * This component provides the Outlet for nested routes and wraps them with RootLayout
 */
export function AppLayout() {
  return (
    <RootLayout>
      <Outlet />
    </RootLayout>
  );
}
